// src/pages/BookmarkedPage.js
import React from 'react';
import { useTranslation } from 'react-i18next';

function BookmarkedPage() {
  const { t } = useTranslation();
  
  return (
    <main className="container py-4" role="main">
      <h1 className="mb-4">{t('bookmarks.title')}</h1>
      <div className="row">
        <div className="col-md-3">
          <div className="card mb-4">
            <div className="card-body">
              <h2 className="h5 card-title">{t('bookmarks.filters')}</h2>
              <div className="mb-3">
                <label htmlFor="stateFilter" className="form-label">{t('bookmarks.state')}</label>
                <select 
                  id="stateFilter" 
                  className="form-select"
                  aria-label={t('bookmarks.filterByState')}
                >
                  <option value="">{t('bookmarks.allStates')}</option>
                  <option value="ny">{t('states.ny')}</option>
                  <option value="ct">{t('states.ct')}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-9">
          <div 
            role="region" 
            aria-label={t('bookmarks.questionsList')}
            className="bookmarked-questions"
          >
            <p className="text-muted text-center">
              {t('bookmarks.noQuestions')}
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default BookmarkedPage;
